exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filediv{\n    display:inline-block;\n}\n.mess_li {\n    width: 100%;\n    margin-top: 30px;\n    list-style: none;\n    text-align: left;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-279d4920","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/referral/referralDetail.vue
// module id = LHvR
// module chunks = 10